// extracted by mini-css-extract-plugin
module.exports = {"triggersDefault":"-triggers-default-triggersDefault-1vnFr5-"};